<template>
  <div class="min-h-screen bg-default text-default" :style="siteThemeStyle">
    <slot />
  </div>
</template>

<script setup lang="ts">
import {
  DEFAULT_FONT_FAMILY,
  DEFAULT_THEME_NEUTRAL,
  DEFAULT_THEME_PRIMARY,
  fontStack,
} from '~/composables/useBuilderMeta'
import { themeCssVarsFromPalette, useSiteUiTheme } from '~/composables/useThemeCssVars'

const { siteSettings } = usePageBlocks()
const colorMode = useColorMode()
const themeSurfaceMode = computed(() => (colorMode.value === 'dark' ? 'dark' : 'light'))

useSiteUiTheme(
  () => siteSettings.value.themePrimary ?? DEFAULT_THEME_PRIMARY,
  () => siteSettings.value.themeNeutral ?? DEFAULT_THEME_NEUTRAL,
)

const siteThemeStyle = computed(() => ({
  ...themeCssVarsFromPalette(
    siteSettings.value.themePrimary ?? DEFAULT_THEME_PRIMARY,
    siteSettings.value.themeNeutral ?? DEFAULT_THEME_NEUTRAL,
    themeSurfaceMode.value,
  ),
  fontFamily: fontStack(siteSettings.value.fontFamily ?? DEFAULT_FONT_FAMILY),
}))
</script>
